import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPushPinStyle0 = cosmosIconCss;

const CosmosIconPushPin$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPushPin extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '70b1a978e05f2a017af10eb23058d13f9ffec4d2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f78dd271c62a753dcde33e3483cc827d3821d541', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0211324e355a4c91d1cb7f12aee89210131eb145', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.825 4.031A2.793 2.793 0 0 1 8.333 2.5h5.336a2.793 2.793 0 0 1-2.493 1.531h-.351ZM6.532 1.238c0-.131.107-.238.239-.238h8.46c.131 0 .238.107.238.238a4.29 4.29 0 0 1-1.969 3.61v4.416A4.002 4.002 0 0 1 16.068 13v.957a.5.5 0 0 1-.5.5H12V21l-2-1.773v-4.77H6.432a.5.5 0 0 1-.5-.5V13A4.001 4.001 0 0 1 8.5 9.263V4.848a4.29 4.29 0 0 1-1.969-3.61ZM12 5.452V9h-1.999V5.452c.267.052.542.08.824.08h.351c.282 0 .558-.028.824-.08Zm2.568 7.506a2.5 2.5 0 0 0-2.5-2.458H9.932a2.5 2.5 0 0 0-2.5 2.457h7.136Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPushPinStyle0; }
}, [1, "cosmos-icon-push-pin", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-push-pin"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-push-pin":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPushPin$1);
            }
            break;
    } });
}

const CosmosIconPushPin = CosmosIconPushPin$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPushPin, defineCustomElement };
